import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  DsButtonV2Component,
  DsModalBottomSheetComponent,
} from '@customdesignsystem';
import {
  EXIT_SUBSCRIPTION_MODAL_TEXTS,
  EXIT_SUBSCRIPTION_MODAL_WIDTH,
} from '../../constants/exit-subscription-modal.constant';

@Component({
  selector: 'app-exit-subscription-modal',
  templateUrl: './exit-subscription-modal.component.html',
  styleUrl: './exit-subscription-modal.component.scss',
  imports: [DsModalBottomSheetComponent, DsButtonV2Component],
})
export class ExitSubscriptionModalComponent {
  @Input() isOpen = false;
  @Output() stay = new EventEmitter<void>();
  @Output() leave = new EventEmitter<void>();

  readonly texts = EXIT_SUBSCRIPTION_MODAL_TEXTS;
  readonly modalWidth = EXIT_SUBSCRIPTION_MODAL_WIDTH;
}
